import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react'

const PaymentModeSelection = ({ setSelectedRadio, selectedRadio, setInitialState, initialState, selectedPlan, setIsAtom }) => {
  return (
    <div>
      <RadioGroup
        aria-label="payment-option"
        name="payment-option"
        value={selectedRadio}
        onChange={(e) => {
          setSelectedRadio(e.target.value);
          setInitialState({ ...initialState, payment_mode: e.target.value });
          if (e.target.value === "CREDIT") {
            setIsAtom(true)
          } else {
            setIsAtom(false)
          }
        }}
        style={{ flexDirection: 'row', fontFamily: 'Montserrat' }}
      >
        {/* {selectedPlan && selectedPlan.recurring ? (
          <>
            <FormControlLabel value="UPI" control={<Radio />} label={<div className='pr-details-table'>UPI</div>} />
            <FormControlLabel value="EMANDATE" control={<Radio />} label={<div className='pr-details-table'>Debit Card / Net Banking</div>} /></>
        ) : (
          <>
            <FormControlLabel value="UPI" control={<Radio />} label={<div className='pr-details-table'>UPI / Debit Card / Net Banking</div>} />
            <FormControlLabel value="CREDIT" control={<Radio />} label={<div className='pr-details-table'>Credit Card</div>} /></>
        )} */}
        {selectedPlan && selectedPlan.recurring && (
          <>
            <FormControlLabel value="UPI" control={<Radio />} label={<div className='pr-details-table'>UPI</div>} />
            <FormControlLabel value="EMANDATE" control={<Radio />} label={<div className='pr-details-table'>Debit Card / Net Banking</div>} /></>
        )}
      </RadioGroup>
    </div>
  )
}

export default PaymentModeSelection;